import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';

const ScrollParagraph = ({ children }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start 0.9", "center 0.5"]
  });
  
  const color = useTransform(scrollYProgress, [0, 1], ['#bbb0ac', '#000000']);
  const opacity = useTransform(scrollYProgress, [0, 1], [0.3, 1]);
  
  return (
    <motion.p ref={ref} className="about-paragraph" style={{ color, opacity }}>
      {children}
    </motion.p>
  );
};

const FadeInWord = ({ children }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-10%" }}
      transition={{ duration: 0.6, ease: "easeOut" }}
    >
      {children}
    </motion.div>
  );
};

const About = () => {
  return (
    <section className="about-section" id="about">
      <div className="about-container">
        <div className="about-content">
          <motion.h2 
            className="section-title"
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            WHO WE ARE
          </motion.h2>
          <div className="about-grid">
            <div className="about-text">
              <motion.h3 
                className="about-heading"
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8 }}
              >
                Meet Medhansh & Raghav
              </motion.h3>
              
              <ScrollParagraph>
                We're not your typical developers. At 15, we've built something different: 
                a creative-first approach to web design that blends AI tools with intuition 
                and visual storytelling.
              </ScrollParagraph>
              
              <ScrollParagraph>
                We don't compete on code—we compete on <strong>experience</strong>. 
                While others build template sites, we craft digital experiences that 
                feel cinematic, interactive, and unforgettable. Our edge? Speed, 
                flexibility, and a design-first mindset.
              </ScrollParagraph>
              
              <ScrollParagraph>
                <strong>Young isn't our weakness</strong>—it's our advantage. We bring 
                fresh perspectives, rapid execution, and genuine collaboration to every project.
              </ScrollParagraph>
              
              <div className="about-stats">
                <FadeInWord>
                  <div className="stat-item">
                    <span className="stat-number">Creative</span>
                    <span className="stat-label">Not Code-Heavy</span>
                  </div>
                </FadeInWord>
                <FadeInWord>
                  <div className="stat-item">
                    <span className="stat-number">Fast</span>
                    <span className="stat-label">Quick Turnarounds</span>
                  </div>
                </FadeInWord>
                <FadeInWord>
                  <div className="stat-item">
                    <span className="stat-number">AI+</span>
                    <span className="stat-label">Human Intuition</span>
                  </div>
                </FadeInWord>
              </div>
            </div>
            <motion.div 
              className="about-images"
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 1 }}
            >
              <div className="about-image-wrapper">
                <img 
                  src="https://customer-assets.emergentagent.com/job_dev-duo-studio/artifacts/nfi9dde9_04aeb230-447e-4e10-84a3-4f521803d82e.jpeg"
                  alt="Medhansh & Raghav - RM WEBWORKS Founders"
                  className="about-image"
                />
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
